import { IconProps } from './types';

export const BinIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28.514 31.46'>
    <g transform='translate(-3.5 -2)'>
      <path
        d='M4.5,9H31.014'
        transform='translate(0 -0.108)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        // eslint-disable-next-line max-len
        d='M28.122,8.892V29.514a2.946,2.946,0,0,1-2.946,2.946H10.446A2.946,2.946,0,0,1,7.5,29.514V8.892m4.419,0V5.946A2.946,2.946,0,0,1,14.865,3h5.892A2.946,2.946,0,0,1,23.7,5.946V8.892'
        transform='translate(-0.054 0)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        d='M15,16.5v8.838'
        transform='translate(-0.189 -0.243)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        d='M21,16.5v8.838'
        transform='translate(-0.297 -0.243)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
    </g>
  </svg>
);
